var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSequelizeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.959 91.9785V163.985L128.093 199.834L127.506 200.346V227.488L128.093 228L218.013 178.273V78H217.155L191.802 91.5759V92.1373",
    fill: "#2F406A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.616 164.406L128.139 200.047V228L37 178V78H37.9175L63.3506 92.1032L63.6193 92.9247V164.719",
    fill: "#2379BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7847 92.557L37 77.8367L127.751 28L218.013 77.631L191.923 91.5854L127.637 56.6747L63.6769 92.4544",
    fill: "#03AFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.944 155.848L126.241 155.19V128.473L126.944 128.117V127.46L151.43 114.076H152.19V141.655L126.782 155.75",
    fill: "#2F406A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.139 143.086V114.076H101.846L126.873 127.835V156.481L100.924 143.083",
    fill: "#2379BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.66 99.6754L101.557 114.232L127.087 128.633L152.19 114.287L126.656 99.519",
    fill: "#03AFEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8968 174.203L95.2278 173.536V146.394L95.8968 146.034V145.367L119.189 131.798H119.911V159.76L95.743 174.049",
    fill: "#2F406A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9114 160.804V131.798H70.6234L95.8608 145.557V174.203L69.9146 160.804",
    fill: "#2379BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0677 117.292L69.9114 131.798L95.443 146.355L120.544 132.008L95.0127 117.241",
    fill: "#03AFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.855 174.836L159.152 174.179V147.442L159.855 147.088V146.43L184.342 133.063H185.101V160.608L159.693 174.684",
    fill: "#2F406A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.578 161.431V132.431H135.393L160.418 146.19V174.836L134.468 161.431",
    fill: "#2379BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.889 117.874L135.101 132.114L160.314 146.355L185.101 132.32L159.889 117.874Z",
    fill: "#03AFEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.842 192.557L128.139 191.89V164.746L128.842 164.386V163.719L153.329 150.152H154.089V178.109L128.68 192.397",
    fill: "#2F406A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.823 179.108V150.152H103.535L128.772 163.911V192.557L102.826 179.105",
    fill: "#2379BD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.268 135.602L102.823 149.94L128.7 164.076L154.089 149.94L128.265 135.595",
    fill: "#03AFEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.944 117.874L126.241 117.205V90.101L126.944 89.7396V89.0713L151.43 75.4688H152.19V103.499L126.944 117.874Z",
    fill: "#2F406A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.139 104.546V75.4688H101.846L126.873 89.2612V117.874L100.924 104.442",
    fill: "#2379BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.658 61.5444L101.557 75.7849L127.089 90.0254L152.19 75.9913L126.658 61.5444Z",
    fill: "#03AFEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8968 135.595L95.2278 134.921V107.301L95.8968 106.937V106.263L119.189 92.5571H119.911V120.801L95.743 135.234",
    fill: "#2F406A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9114 122.199V93.1899H70.6234L95.8608 106.949V135.595L69.9146 122.196",
    fill: "#2379BD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0677 78.6328L69.9114 92.7967L95.443 107.114L120.544 93.1056L95.0127 78.686",
    fill: "#03AFEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.855 136.861L159.152 136.183V108.654L159.855 108.287V107.609L184.342 93.8228H185.101V122.234L159.693 136.752",
    fill: "#2F406A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.101 123.402V93.8228H135.884L159.785 107.753V136.861L135.101 123.402Z",
    fill: "#2379BD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M159.889 79.2724L135.101 93.5066L160.314 107.747L185.101 93.713L159.889 79.2661",
    fill: "#03AFEF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.842 153.946L128.139 153.267V125.78L128.842 125.413V124.733L153.329 110.912H154.089V139.394L128.842 153.95",
    fill: "#2F406A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.823 140.451V110.912H103.535L128.772 124.926V153.95L102.823 140.451Z",
    fill: "#2379BD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.294 96.9873L102.823 111.202L128.673 125.468L154.089 111.409L128.297 96.9936",
    fill: "#03AFEF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequelizeDark);
export default __webpack_public_path__ + "static/media/Sequelize-Dark.31164b3627b8cb513ebc8310d3c94a5a.svg";
export { ForwardRef as ReactComponent };